export interface GeneralNewsRouter {
  goToDetail(id: string): void;
  goToList(query?: string): void;
  goBack(prevState: { pathname: string; search: string }): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GeneralNewsRouter = Symbol('GeneralNewsRouter');
